import { createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "col-12 mb-4" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
            _createStaticVNode("<div class=\"col-12 bg-white border rounded pt-3 pb-4\"><div class=\"row border-bottom mb-3\"><div class=\"col-12\"><div class=\"font7 mb-2\">Schritt 3 von 3</div><h2 class=\"h5 mb-3\">Deine Versandart</h2></div></div><div class=\"strong\">Bitte wähle zuerst, wie du dein Geld erhalten möchtest.</div></div>", 1)
        ]))]));
}
